export default __webpack_public_path__ + "src/images/packages/clifftop-exclusive-safari/c3e13766755d3fc100fc672382afef9d-3.jpeg";